import React, {Fragment} from 'react';
import {Checkbox} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Segment, Header, Grid, Form} from 'semantic-ui-react';
import connectWithCore from 'framework/hocs/connectWithCore';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {getItemNameFromRef} from 'common/utils';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class PanelChairReview extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {reviewerList: [], reviewerPKList: [], userEmailTable: false};

  componentDidMount() {
    const {scores, context} = this.props;
    const toggles = context.toggles.toggles;
    this.setState({userEmailTable: _.includes(toggles, 'userEmailTable')}, () => {
      this.getPartCodeList(scores);
    });
  }

  componentDidUpdate(prevProps) {
    const {scores} = this.props;
    const prevScores = _.get(prevProps, 'scores');
    if (!_.isEqual(prevScores, scores)) {
      this.getPartCodeList(scores);
    }
  }

  renderScoresSection(factor) {
    const scoreReviewer = this.state.userEmailTable ? 'emailAdr' : 'userId';

    const scoresSection = (filteredScores) =>
      _.map(filteredScores, (score) => {
        return (
          <FemaGoTable.Row>
            <FemaGoTable.TextCell>{score[scoreReviewer]}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {score.text ? score.text : score.value}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{score.justification}</FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    const filteredScores = _.orderBy(factor, ['userId'], ['asc']);

    return scoresSection(filteredScores);
  }

  getPartCodeList(scores) {
    let partCodes = [];
    let reviewerList = this.state.userEmailTable ? [{}] : [];

    if (this.state.userEmailTable) {
      _.forEach(scores, (score) => {
        if (score.part) {
          partCodes.push(score.part);

          reviewerList.push({userId: score.userId, emailAdr: score.emailAdr});
        }
      });
    } else {
      _.forEach(scores, (score) => {
        if (score.part) {
          partCodes.push(score.part);

          reviewerList.push(score.userId);
        }
      });
    }

    let partCode = _.filter(_.uniq(partCodes), (part) => {
      return !_.isNaN(_.toNumber(part));
    });

    if (this.state.userEmailTable) {
      this.setState({
        reviewers: _.map(_.uniqBy(reviewerList, 'userId'), 'userId'),
        reviewerPKList: _.uniq(reviewerList),
      });
    } else {
      this.setState({
        reviewers: _.uniq(reviewerList),
      });
    }

    REST.ref
      .getItemsByItemCodes(this.props.token, partCode)
      .then((res) => forceJsonResponse(res, MONO))
      .then((itemData) => {
        this.setState({
          refItems: itemData,
        });
      })
      .catch((err) => {
        console.error('Error retrieving ItemCodes from Ref');
      });
  }

  renderReviewersSection(reviewers) {
    let reviewerEmail;
    const {reviewerList, reviewerPKList} = this.state;

    const scoresSection = (reviewers) =>
      _.map(reviewers, (reviewer, index) => {
        const value = _.get(reviewerList, [reviewer]);

        if (this.state.userEmailTable) {
          const reviewerInfo = _.find(reviewerPKList, {userId: reviewer});

          if (reviewerInfo) {
            reviewerEmail = reviewerInfo.emailAdr;
          }
        }

        const inputId = index === 0 ? 'content' : 'checkbox' + _.uniqueId();

        if (!_.isEmpty(reviewer)) {
          return (
            <>
              <FemaGoTable.Row>
                <FemaGoTable.TextCell>
                  {this.state.userEmailTable ? reviewerEmail : reviewer}
                </FemaGoTable.TextCell>
                <FemaGoTable.TextCell>
                  <div className="field">
                    <div className="ui checkbox">
                      <label for={inputId} id="gmm-checkbox-label" className="">
                        <input
                          type="checkbox"
                          id={inputId}
                          name={this.state.userEmailTable ? reviewerEmail : reviewer}
                          className="hidden"
                          checked={value}
                          onChange={(e) => {
                            this.handleReReviewerChange(e.target.checked, reviewer);
                          }}
                        />
                        <span className="after-prop-elem"></span>
                        <span className="label-text sr-only">
                          {this.state.userEmailTable ? reviewerEmail : reviewer}
                        </span>
                      </label>
                    </div>
                  </div>
                </FemaGoTable.TextCell>
              </FemaGoTable.Row>
            </>
          );
        }
      });
    return scoresSection(reviewers);
  }

  handleReReviewerChange = (value, reviewer) => {
    const {entityDataPath, saveEntityData} = this.props;

    this.setState({reviewerList: {...this.state.reviewerList, [reviewer]: value}}, () => {
      const filteredReviewerList = _.compact(
        _.map(this.state.reviewerList, (value, reviewer) => {
          if (value) return reviewer;
        })
      );
      saveEntityData(entityDataPath, null, filteredReviewerList);
    });
  };

  renderPanelReviewScores(scores, fundingStreams, refItems) {
    let scoresParsed = {};
    scores = _.orderBy(scores, 'sortOrder');
    if (this.props.definedScoreSort) {
      scores = _.orderBy(
        scores,
        this.props.definedScoreSort.iteratees.map((sortDescription) => {
          if (sortDescription.values && Array.isArray(sortDescription.values)) {
            return (item) => sortDescription.values.indexOf(item[sortDescription.key]);
          } else {
            return sortDescription;
          }
        }),
        this.props.definedScoreSort.orders
      );
    }
    _.forEach(scores, (score) => {
      if (score.part) {
        let partName = getItemNameFromRef(score.part, refItems) || score.part;
        let projectName = _.get(
          fundingStreams,
          `${score.partId}.additionalInformation.projectName`,
          ''
        );
        partName = projectName ? partName + ' ' + projectName : partName;

        let currentScores = _.get(scoresParsed, [partName, score.factor], []);
        currentScores.push(score);
        _.set(scoresParsed, [partName, score.factor], currentScores);
      }
    });
    return (
      <Segment padded>
        <Header as="h1" content="Panel review scores" />

        {_.map(scoresParsed, (part, index) => {
          return (
            <React.Fragment>
              <Header as="h2" content={index} />
              {_.map(part, (factor, index) => {
                return (
                  <Segment padded>
                    <Header as="h3" content={index} />
                    <FemaGoTable
                      summary={`${index}`}
                      type="static"
                      columns={3}
                      withForm={false}
                    >
                      <FemaGoTable.Header>
                        <FemaGoTable.Row key="participatingAgenciesTableHeader">
                          <FemaGoTable.HeaderCell>Reviewer</FemaGoTable.HeaderCell>
                          <FemaGoTable.HeaderCell>Score</FemaGoTable.HeaderCell>
                          <FemaGoTable.HeaderCell>Comment</FemaGoTable.HeaderCell>
                        </FemaGoTable.Row>
                      </FemaGoTable.Header>
                      <FemaGoTable.Body>
                        {this.renderScoresSection(factor)}
                      </FemaGoTable.Body>
                    </FemaGoTable>
                  </Segment>
                );
              })}
            </React.Fragment>
          );
        })}
      </Segment>
    );
  }

  renderReReviewCheckboxList(reviewers) {
    return (
      <Segment padded>
        <FemaGoTable
          summary={'ReReview Needed?'}
          type="static"
          columns={2}
          withForm={false}
        >
          <FemaGoTable.Header>
            <FemaGoTable.Row key="reviewerListHeader">
              <FemaGoTable.HeaderCell>Reviewer</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>ReReview Needed</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>{this.renderReviewersSection(reviewers)}</FemaGoTable.Body>
        </FemaGoTable>
      </Segment>
    );
  }

  render() {
    const refItems = _.get(this.state, 'refItems', {});
    const reviewers = _.get(this.state, 'reviewers', {});
    const {scores, fundingStreams} = this.props;

    return (
      <React.Fragment>
        {_.size(scores) > 0
          ? this.renderPanelReviewScores(scores, fundingStreams, refItems)
          : null}
        {_.size(reviewers) > 0 ? this.renderReReviewCheckboxList(reviewers) : null}
      </React.Fragment>
    );
  }
}

export default connectWithCore(PanelChairReview);
